import React from 'react';
import { useTranslation } from 'react-i18next';
import { Award, Clock, Users, Shield } from 'lucide-react';

export const WhyChooseEDX = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: Clock,
      title: t('whyChoose.experience'),
      description: t('whyChoose.experienceText'),
    },
    {
      icon: Award,
      title: t('whyChoose.quality'),
      description: t('whyChoose.qualityText'),
    },
    {
      icon: Users,
      title: t('whyChoose.satisfaction'),
      description: t('whyChoose.satisfactionText'),
    },
    {
      icon: Shield,
      title: t('whyChoose.professional'),
      description: t('whyChoose.professionalText'),
    },
  ];

  return (
    <section className="py-24 bg-[hsl(210,40%,98%)]" data-testid="why-choose-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2
            className="text-4xl sm:text-5xl font-bold text-[hsl(215,75%,16%)] mb-4 tracking-tight"
            style={{ fontFamily: 'Outfit' }}
          >
            {t('whyChoose.title')}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {t('whyChoose.subtitle')}
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="bg-white rounded-lg p-8 text-center card-hover"
                data-testid={`feature-card-${index}`}
              >
                {/* Icon */}
                <div className="mb-6 flex justify-center">
                  <div className="w-20 h-20 bg-[hsl(215,75%,16%)] rounded-full flex items-center justify-center">
                    <Icon className="w-10 h-10 text-white" />
                  </div>
                </div>

                {/* Content */}
                <h3
                  className="text-xl font-bold text-[hsl(215,75%,16%)] mb-3"
                  style={{ fontFamily: 'Outfit' }}
                >
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed text-sm">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};